import * as restApi from "./restApi";
import { assertId, assertNumber } from "./restApi";
import { ManufacturerVisibility } from "@/types/admin/division-manager";

const collectionUrl = "api/division-manager/divisions";
const enc = encodeURIComponent;

export const fetchDivisions = restApi.fetchRecords.bind(null, {}, collectionUrl);
export const fetchRecord = restApi.fetchRecord.bind(null, {}, collectionUrl);

// roles

export function fetchDivisionRoles(divisionId: string): Promise<unknown> {
  assertId(divisionId);
  return restApi.fetchRecords({}, `${collectionUrl}/${enc(divisionId)}/roles`);
}

export function fetchDivisionRole(divisionId: string, roleId: string): Promise<unknown> {
  return restApi.fetchRecord({}, `${collectionUrl}/${enc(divisionId)}/roles`, roleId);
}

export function existsDivisionRole(divisionId: string, roleId: string): Promise<unknown> {
  assertId(divisionId);
  return restApi.existsRecord({}, `${collectionUrl}/${enc(divisionId)}/roles`, roleId);
}

export function insertDivisionRole(divisionId: string, record: unknown): Promise<unknown> {
  assertId(divisionId);
  return restApi.insertRecord({}, `${collectionUrl}/${enc(divisionId)}/roles`, record);
}

export function updateDivisionRole(divisionId: string, roleId: string, record: unknown): Promise<unknown> {
  assertId(divisionId);
  return restApi.updateRecord({}, `${collectionUrl}/${enc(divisionId)}/roles`, roleId, record);
}

export function deleteDivisionRole(divisionId: string, roleId: string): Promise<unknown> {
  assertId(divisionId);
  return restApi.deleteRecord({}, `${collectionUrl}/${enc(divisionId)}/roles`, roleId);
}

// users

export function fetchDivisionUsers(divisionId: string): Promise<unknown> {
  assertId(divisionId);
  return restApi.fetchRecords({}, `${collectionUrl}/${enc(divisionId)}/users`);
}

export function addDivisionRoleUser(divisionId: string, roleId: string, userId: number): Promise<unknown> {
  assertId(divisionId) && assertId(roleId) && assertNumber(userId);
  return restApi.updateRecord({}, `${collectionUrl}/${enc(divisionId)}/roles/${enc(roleId)}/users`, userId, {});
}

export function removeDivisionRoleUser(divisionId: string, roleId: string, userId: string): Promise<unknown> {
  assertId(divisionId) && assertId(roleId) && assertNumber(userId);
  return restApi.deleteRecord({}, `${collectionUrl}/${enc(divisionId)}/roles/${enc(roleId)}/users`, userId);
}

// permissions

export function fetchDivisionPermissions(divisionId: string): Promise<unknown> {
  return restApi.fetchRecords({}, `${collectionUrl}/${enc(divisionId)}/permissions`);
}

export function assignDivisionRolePermission(divisionId: string, roleId: string, permissionId: string): Promise<unknown> {
  assertId(divisionId) && assertId(roleId) && assertId(permissionId);
  return restApi.updateRecord({}, `${collectionUrl}/${enc(divisionId)}/roles/${enc(roleId)}/permissions`, permissionId, {});
}

export function removeDivisionRolePermission(divisionId: string, roleId: string, permissionId: string): Promise<unknown> {
  assertId(divisionId) && assertId(roleId) && assertId(permissionId);
  return restApi.deleteRecord({}, `${collectionUrl}/${enc(divisionId)}/roles/${enc(roleId)}/permissions`, permissionId);
}

// systems

export function fetchDivisionSystems(divisionId: string): Promise<unknown> {
  assertId(divisionId);
  return restApi.fetchRecords({}, `${collectionUrl}/${enc(divisionId)}/systems`);
}

export function addDivisionRoleSystem(divisionId: string, roleId: string, manufacturerId: string, systemId: string): Promise<unknown> {
  assertId(divisionId) && assertId(roleId) && assertId(manufacturerId) && assertId(systemId);
  return restApi.updateRecord({}, `${collectionUrl}/${enc(divisionId)}/roles/${enc(roleId)}/systems/${enc(manufacturerId)}`, systemId, {});
}

export function removeDivisionRoleSystem(divisionId: string, roleId: string, manufacturerId: string, systemId: string): Promise<unknown> {
  assertId(roleId) && assertId(manufacturerId) && assertId(systemId);
  return restApi.deleteRecord({}, `${collectionUrl}/${enc(divisionId)}/roles/${enc(roleId)}/systems/${enc(manufacturerId)}`, systemId);
}

// manufacturers

export function fetchDivisionManufacturers(divisionId: string): Promise<unknown> {
  assertId(divisionId);
  return restApi.fetchRecords({}, `${collectionUrl}/${enc(divisionId)}/manufacturers`);
}

export function fetchDivisionManufacturerVisibility(divisionId: string): Promise<ManufacturerVisibility[]> {
  assertId(divisionId);
  return restApi.fetchRecords({}, `${collectionUrl}/${enc(divisionId)}/visibility`);
}
